export default "__VITE_ASSET__lx43Lfp___"